import React from "react";
import LeftArrowSvg from "assets/icons/left_arrow.svg";
import CloseSvg from "assets/icons/close-gray.svg";
import { AlarmContainer, AlarmContent, AlarmHeader } from "./AlarmStyle";
import { useNavigate } from "react-router-dom";

const Alarm = () => {
  const navigate = useNavigate();
  return (
    <AlarmContainer>
      <AlarmHeader className="alarm-header">
        <img
          src={LeftArrowSvg}
          alt="Back Link Button"
          onClick={() => navigate(-1)}
        />
        <h2>알림</h2>
      </AlarmHeader>
      <AlarmContent className="alarm-section">
        <li className="already-read-alarm">
          <span className="alarm-title-wrapper">
            <strong className="alarm-title">커뮤니티</strong>
            <img src={CloseSvg} alt="remove alarm" />
          </span>
          <p className="alarm-content">
            ㅇㅇㅇ님이 ㅇㅇㅇ님의 글, ‘글 미리보기 20자까지 초과는 ...처리’
            게시글에 댓글을 남겼어요.
          </p>
          <p className="alarm-time">8시간 전</p>
        </li>
        <li>
          <span className="alarm-title-wrapper">
            <strong className="alarm-title">커뮤니티</strong>
            <img src={CloseSvg} alt="remove alarm" />
          </span>
          <p className="alarm-content">
            ㅇㅇㅇ님이 ㅇㅇㅇ님의 글, ‘글 미리보기 20자까지 초과는 ...처리’
            게시글에 댓글을 남겼어요.
          </p>
          <p className="alarm-time">8시간 전</p>
        </li>
        <li>
          <span className="alarm-title-wrapper">
            <strong className="alarm-title">커뮤니티</strong>
            <img src={CloseSvg} alt="remove alarm" />
          </span>
          <p className="alarm-content">
            ㅇㅇㅇ님이 ㅇㅇㅇ님의 글, ‘글 미리보기 20자까지 초과는 ...처리’
            게시글에 댓글을 남겼어요.
          </p>
          <p className="alarm-time">8시간 전</p>
        </li>
      </AlarmContent>
    </AlarmContainer>
  );
};

export default Alarm;
